import { z } from 'zod';

import { contentStatuses, customBagFormSchema } from './block-form-schema';

const HANDLE = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const MAX_SECTION_BLOCKS = 50;

/** Blocks are managed beside the form with their own PUT, like a collection's product list. */
export const sectionFormSchema = z.object({
  handle: z
    .string()
    .trim()
    .min(1, { error: 'content:validation.handleRequired' })
    .max(120)
    .regex(HANDLE, { error: 'content:validation.handleFormat' }),
  name: z
    .string()
    .trim()
    .min(1, { error: 'content:validation.nameRequired' })
    .max(120, { error: 'content:validation.nameLength' }),
  title: z.string().trim().max(200, { error: 'content:validation.titleLength' }),
  description: z
    .string()
    .trim()
    .max(2000, { error: 'content:validation.sectionDescriptionLength' }),
  status: z.enum(contentStatuses),
  custom: customBagFormSchema,
});

export type SectionFormInput = z.input<typeof sectionFormSchema>;
export type SectionFormOutput = z.output<typeof sectionFormSchema>;
